export const AUDIO_NODE_NAME = 'audio';
// Deliberately not `audio`: `parseHTML` matches on this tag, and claiming the real element would let
// pasted HTML create nodes that never went through `setAudio` and so carry no `audioId`.
export const AUDIO_TAG = 'audio-button';
